import React, { useState } from "react";
import {
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import MenuIcon from "@material-ui/icons/Menu";
import ViewModuleIcon from "@material-ui/icons/ViewModule";

const MenuToggle = ({ onMenuTypeChange, currentMenuType = "vertical" }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuTypeChange = (type) => {
    onMenuTypeChange(type);
    localStorage.setItem("menuType", type);
    handleClose();
    // Recarregar a página para aplicar a mudança
    window.location.reload();
  };

  return (
    <>
      <Tooltip title="Configurar Menu">
        <IconButton
          onClick={handleClick}
          size="small"
          style={{ 
            marginLeft: 16,
            color: "rgba(255, 255, 255, 0.9)"
          }}
        >
          <SettingsIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            marginTop: 8,
            minWidth: 200,
            borderRadius: 8,
          },
        }}
      >
        <MenuItem 
          onClick={() => handleMenuTypeChange("vertical")}
          selected={currentMenuType === "vertical"}
        >
          <ListItemIcon>
            <MenuIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Menu Vertical (Lateral)</ListItemText>
        </MenuItem>
        <MenuItem 
          onClick={() => handleMenuTypeChange("horizontal")}
          selected={currentMenuType === "horizontal"}
        >
          <ListItemIcon>
            <ViewModuleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Menu Horizontal</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default MenuToggle;